import {
  ActivityIndicator,
  StyleSheet,
  Text,
  TextInput,
  View
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import React, { useEffect, useState } from 'react'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { Formik } from 'formik'
import Card from '../../shared/card/Card'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import CustomButton from '../../shared/button/Button'
import { useFormsStore } from '../../../stores/onboarding'
import * as yup from 'yup'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'

const KsinformationForm = ({ navigation, route }: any) => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params
  const personalstore = usePersonalStore()
  const intializeStore = useInitializeStore()
  const { loading, postKSonline, getmodetails } = useFormsStore()
  const intialValues = {
    AllowanceRate: '',
    Total: '',
    exempt: '',
    additional: ''
  }
  useEffect(() => {
    getmodetails(intializeStore?.initializeData?.userkey)
  }, [])
  const w4schema = () => {
    const baseSchema = {
      AllowanceRate: yup.string().required('Filing status is a required field'),
      exempt: yup
        .string()
        .matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
        .nullable(),
    }
    return yup.object(baseSchema)
  }
  const schema = w4schema()

  const options1 = [
    { key: 1, value: 'Single', option: 'S' },
    { key: 2, value: 'Joint', option: 'M' },
  ]
  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'Kansas Withholding'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={schema}
          onSubmit={async (values, actions) => {

            const data = {
              entityId: personalstore?.personalData?.entityId,
              essUserKey: intializeStore?.initializeData?.userkey,
              essObKey: essUserOnBoardingKey,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              completeOnline: mode === 'upload' ? false : true,
              allowanceRate: values?.AllowanceRate,
              Total: values?.Total ? values?.Total : null,
              additionalAmount: values?.additional ? values?.additional : null,
              withholdingExempt: values?.exempt
            }
            console.log("datadatadatadata", data);
            const response = await postKSonline(data)
            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('KsinformationOnline', {
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                  completeOnline: mode === 'upload' ? false : true
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
            }
            else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }

          }}
        >
          {(props) => (
            <Card>
              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ justifyContent: 'center', width: '50%' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {'Filing status *'}
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <SelectKeyValue
                    title="Filing status"
                    options={options1}
                    selectedOption={mapSelectValue(
                      options1,
                      props.values.AllowanceRate
                    )}
                    onSelect={(option: any) => {
                      for (let i = 0; i < options1.length; i++) {
                        if (option == options1[i].key) {
                          props.setFieldValue(
                            'AllowanceRate',
                            options1[i].option
                          )
                        }
                      }
                    }}
                    textColor="primary"
                  />
                  {props.touched.AllowanceRate &&
                    props.errors.AllowanceRate && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.AllowanceRate}
                      </Text>
                    )}
                </View>
              </View>

              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ width: '70%', justifyContent: 'center' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {
                      'Total number of allowances you are claiming :'
                    }
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <TextInput
                    style={[globalStyles.input, globalStyles.inputLight]}
                    value={props.values.Total}
                    keyboardType="numeric"
                    onChangeText={(text) => {
                      if (text === '' || /^\d+$/.test(text)) {
                        props.handleChange('Total')(text)
                      }
                    }}
                  />
                  {props.touched.Total && props.errors.Total && (
                    <Text style={globalStyles.dangerAlert}>
                      {props.errors.Total}
                    </Text>
                  )}
                </View>
              </View>

              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ width: '70%', justifyContent: 'center' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {'If you claim exempt from withholding, enter exempt.'}
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <TextInput
                    style={[globalStyles.input, globalStyles.inputLight]}
                    value={props.values.exempt}
                    onChangeText={(text) => {
                      props.handleChange('exempt')(text)
                      if (text?.toLowerCase() === 'exempt') {
                        props.setFieldValue('additional', '')
                      }
                    }}
                  />
                  {props.touched.exempt && props.errors.exempt && (
                    <Text style={globalStyles.dangerAlert}>
                      {props.errors.exempt}
                    </Text>
                  )}
                </View>
              </View>

              {props.values.exempt?.toLowerCase() !== 'exempt' && (
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'Enter any additional amount you want withheld from each paycheck :'
                      }
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.additional}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('additional')(text)
                        }
                      }}
                    />
                    {props.touched.additional && props.errors.additional && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.additional}
                      </Text>
                    )}
                  </View>
                </View>
              )}


              {loading ? (
                <ActivityIndicator />
              ) : (
                <View style={{ margin: 10 }}>
                  <CustomButton
                    text={mode === 'upload' ? 'Submit Information' : 'Next'}
                    onPress={props.handleSubmit}
                  />
                </View>
              )}
            </Card>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}

export default KsinformationForm

const styles = StyleSheet.create({})
